export const isNotLocalized = ({ pathname }) => !/localized/.test(pathname);

export const getDefaultVersion = ({ versions, defaultVersion }) =>
  versions.find(({ type }) => type === defaultVersion) ||
  versions[versions.length - 1];
